import { useState } from "react"
import useForm from "../hooks/useForm"
import FormFieldText from "./Form/FormFieldText"
import { sendEducationSubscriptionForm } from "../utils/api"

const EducationSubscriptionForm = ({ course }) => {
  const [isFormSent, setIsFormSent] = useState(false)

  const {
    fields,
    invalidFields,
    validateFieldMemoized,
    setFieldMemoized,
    setFieldMultiple,
    handleSubmit,
    isSubmitting,
    error,
  } = useForm({
    
  }, {
    email: (value) => value?.length < 1 || !value.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i),
  }, async (fields, setError) => {
    const response = await sendEducationSubscriptionForm({ course_id: course.id, email: fields.email })

    if (!response.success) {
      setError('Ошибка отправки формы')
      return
    }

    setIsFormSent(true)
  })

  return (
    <form onSubmit={handleSubmit}>
      <div className={`education-modal-block ${isFormSent ? 'display-none' : ''}`}>
        <div>К сожалению, на данный момент нет свободных мест для записи на это мероприятие.</div>
        <div>Вы можете оставить свой e-mail, и мы сообщим вам, когда появятся свободные места.</div>
        <FormFieldText
          value={fields?.email ?? ''}
          isInvalid={invalidFields.email}
          placeholder={'Эл. почта'}
          onChange={setFieldMemoized('email')}
          validateField={validateFieldMemoized('email')}
        />
        <button type="submit" className={`button-big-primary-wide ${(isSubmitting || !fields?.email) ? 'disabled' : ''}`}>
          {isSubmitting ? 'Загрузка...' : 'Подписаться'}
        </button>
      </div>
      {isFormSent && <div className="form-success">Спасибо, вы подписаны на уведомления о появлении свободных мест!</div>}
    </form>
  )
}

export default EducationSubscriptionForm